const admin = {
  title: "Журнал разработки",
  subtitle: "Обзор системы и реестр компонентов",
  breadcrumbDashboard: "Дашборд",
  breadcrumbAdmin: "Рабочая область администратора",
  lastUpdated: "Последнее обновление",
  branch: "Ветка",
  activePages: "Активные страницы",
  placeholderPages: "Заглушки",
  components: "Компоненты",
  fieldsMapped: "Маппинг полей",
  widgetsLabel: "Виджеты",
  contextsLabel: "Контексты",
  phaseProgress: "Прогресс по фазам",
  phase1: "Фаза 1 — Фундамент",
  phase2: "Фаза 2 — Редактор",
  phase3: "Фаза 3 — Карта историй",
  phase4: "Фаза 4 — AI Центр",
  phase5: "Фаза 5 — Дополнения",
  tabRoutes: "Страницы и маршруты",
  tabWidgets: "Виджеты",
  tabContexts: "Контексты",
  filterPhase: "Фаза",
  filterStatus: "Статус",
  filterAll: "Все",
  dashboardRoutes: "Маршруты дашборда",
  standalonePages: "Отдельные страницы",
  visible: "Видимый",
  hidden: "Скрытый",
  sidebar: "Боковая панель",
  statusActive: "Активный",
  statusPlaceholder: "Заглушка",
  statusComingSoon: "Скоро",
  statusDeprecated: "Устаревший",
  architectureStack: "Технологический стек",
  tabChangelog: "Журнал изменений",
  tabStoryMap: "Карта историй",
  changelogTitle: "Журнал изменений и отслеживание",
  committedChanges: "Зафиксированные изменения",
  uncommittedChanges: "Незафиксированные изменения",
  untrackedFiles: "Новые файлы",
  modifiedFiles: "Изменённые файлы",
  dataCcIdSystem: "Система data-cc-id",
  dataCcIdExplanation: "Уникальные идентификаторы на элементах UI для динамических стилей через StyleOverrideContext. Каждый элемент с data-cc-id можно настроить в Настройках.",
  dataCcIdTextExplanation: "Элементы с data-cc-text=\"true\" также поддерживают редактирование текста.",
  totalIds: "Всего ID",
  textEditableIds: "Редактируемые",
  filesWithIds: "Файлов с ID",
  featureStatus: "Статус фичи",
  working: "Работает",
  notVerified: "Не проверено",
  broken: "Сломано",
  committed: "Зафиксировано",
  uncommitted: "Не зафиксировано",
  feature: "Фича",
  status: "Статус",
  files: "Файлы",
  notes: "Заметки",
  commitHash: "Коммит",
  directLink: "Прямая ссылка",
  searchChangelog: "Поиск в журнале",
  searchPlaceholder: "Искать фичу, файл, коммит...",
  directMatches: "Прямые совпадения",
  relatedConnected: "Связанные и подключённые",
  noSearchResults: "Результаты не найдены",
  architectureDiagram: "Карта архитектуры",
  diagramLoading: "Загрузка диаграммы...",
  commitButton: "Зафиксировать изменения",
  deployButton: "Развернуть в продакшн",
  commitPlaceholder: "Описание изменений...",
  commitSuccess: "Коммит выполнен",
  commitError: "Ошибка коммита",
  deploySuccess: "Развёртывание успешно",
  deployError: "Ошибка развёртывания",
  devOnly: "Только для разработки",
  enterCommitMessage: "Введите сообщение коммита",
  confirmDeploy: "Вы уверены? Это сделает коммит и отправку в main",
  loadingGit: "Загрузка статуса git...",
  gitError: "Ошибка загрузки статуса git",
  liveStatus: "Текущий статус",
  pushing: "Отправка...",
  committing: "Фиксация...",
  nothingToCommit: "Нечего фиксировать",
  wfInbox: "Входящие",
  wfWishlist: "Список желаний",
  wfTodo: "К выполнению",
  wfNext: "Следующий",
  wfInProgress: "В работе",
  wfHold: "На паузе",
  wfStuck: "Застрял",
  wfFreeze: "Заморожен",
  wfComplete: "Завершён",
  wfCancelled: "Отменён",
  sortBy: "Сортировать по",
  sortDate: "Дата",
  sortName: "Название",
  sortPhase: "Фаза",
  sortWorkflow: "Рабочий процесс",
  sortFileCount: "Кол-во файлов",
  groupBy: "Группировать по",
  groupNone: "Без группировки",
  groupWorkflow: "Рабочий процесс",
  groupPhase: "Фаза",
  groupDate: "Дата",
  groupFileDir: "Каталог",
  filterWorkflow: "Рабочий процесс",
  filterTechStatus: "Технический статус",
  workflowStatus: "Статус процесса",
  noPhase: "Без фазы",
  devChecklist: "Чеклист разработки",
  devChecklistTitle: "Чеклист разработки — Завершение фич",
  checklistDone: "Чеклист выполнен",
  checklistItemsDone: "Пунктов выполнено",
  noChecklist: "Нет чеклиста",
  reviewedBy: "Проверено",
  clGuideContent: "Содержание гайда",
  clUsageDoc: "Документация",
  clDiagram: "Диаграмма",
  clAiSourceOfTruth: "AI-источник истины",
  clConflictReview: "Проверка конфликтов",
  clGuideContentDesc: "data-cc-id + styleOverrideRegistry + i18n",
  clUsageDocDesc: "Полное описание purpose + notes",
  clDiagramDesc: "connectedTo заполнено, отображается в Mermaid",
  clAiSourceOfTruthDesc: "Полное purpose, ссылка в CLAUDE.md",
  clConflictReviewDesc: "Проверены зависимости, контексты, localStorage, события",
  auditLinkTitle: "Аудит кода — Мульти-ревью",
  auditLinkSubtitle: "4 роли · план · реальность · качество · целостность",
  layerKnowledge: "Знания",
  layerAutomation: "Автоматизация",
  layerMessaging: "Сообщения",
  whyBuilt: "Зачем это сделано",
  connectedToLabel: "Связано с:",
  moreFiles: "файлов",
  results: "результатов",
  phaseLabel: "Фаза",
  hasRoute: "с маршрутом",
  noRoute: "без маршрута",
  connectedToLegend: "связано с",
  routeVisible: "Видимый",
  routeHidden: "Скрытый",
  routeSidebar: "Боковая панель",
  routeComponents: "Компоненты",
  routeContexts: "Контексты:",
  routeTables: "Таблицы:",
  smStories: "Истории",
  smDone: "Готово",
  smMissing: "Отсутствует",
  smBroken: "Сломано",
  smCriticalRisks: "Критические риски",
  smComplete: "Завершение",
  smUserJourney: "Путь пользователя",
  smReleaseTiers: "Уровни релиза",
  smRisksTimeline: "Риски + Таймлайн",
  smStatusDone: "Готово",
  smStatusBroken: "Сломано",
  smStatusMissing: "Отсутствует",
  smStatusUntested: "Не тестировано",
  smRiskLow: "Низкий",
  smRiskMedium: "Средний",
  smRiskHigh: "Высокий",
  smRiskCritical: "Критический",
  smEmotion: "Эмоция",
  smFriction: "Трение",
  smAha: "Ага!",
  smThStory: "История",
  smThStatus: "Статус",
  smThRisk: "Риск",
  smThFile: "Файл",
  smThTask: "Задача",
  smThEffort: "Трудозатраты",
  smUnhappyPaths: "Негативные сценарии",
  smTasks: "задач",
  smRiskMatrix: "Матрица рисков",
  smRiskCol: "Риск",
  smType: "Тип",
  smLevel: "Уровень",
  smMitigation: "Смягчение",
  smImplSequence: "Последовательность реализации",
  smMlpSubtitle: "Продукт, который любят",
  smMlpKpis: "KPI: Ежедневное использование >80%, Создание документа <2мин, AI-сессий >10/неделя/пользователь, Удовлетворённость >4/5",
  smVerificationTitle: "Проверка по уровню",
  smVerifyWs: "Вход → дашборд рендерится → проекты видны",
  smVerifyMvp: "Все 12 страниц работают, CRUD по всем таблицам, AI стриминг, realtime синхронизация",
  smVerifyMlp: "Полный путь пользователя без демо-данных, все интеграции активны, опрос удовлетворённости >4/5",
  wfLabelInbox: "Входящие",
  wfLabelWishlist: "Желаемое",
  wfLabelTodo: "К выполнению",
  wfLabelNext: "Следующий",
  wfLabelInProgress: "В работе",
  wfLabelHold: "На паузе",
  wfLabelStuck: "Застрял",
  wfLabelFreeze: "Заморожен",
  wfLabelComplete: "Завершён",
  wfLabelCancelled: "Отменён",
} as const;
export default admin;
